
import { defineComponent, onMounted, onUnmounted, nextTick, ref } from "vue";
import useArticle from "@/views/agreement/article/useArticle";
// 1. 移除 ImagePreview 导入（不再需要图片预览）

export default defineComponent({
  name: "Article",
  setup() {
    const { agreementContent } = useArticle(() => listenImg()); // 解构核心数据，避免展开所有
    const htmlRef = ref<HTMLDivElement>(null); // 绑定 v-html 容器，精准获取图片

    // 2. 监听图片事件：仅阻止默认预览，不阻止页面缩放
    function listenImg() {
      nextTick(() => { // 确保 v-html 渲染完成
        if (!htmlRef.value) return;
        // 精准获取 v-html 内的图片（避免影响页面其他图片）
        const imgs = htmlRef.value.querySelectorAll('img');
        imgs.forEach(img => {
          // 绑定触摸事件（阻止图片原生预览）
          img.addEventListener('touchstart', handleTouchStart, { passive: false });
          img.addEventListener('touchmove', handleTouchMove, { passive: false });
          img.addEventListener('click', handleImgClick, { passive: false }); // 拦截点击预览
        });
      });
    }

    // 3. 触摸开始：仅记录状态，不做预览
    function handleTouchStart(e: TouchEvent) {
      // 无需存储触摸点，仅确保不阻止默认行为（除了图片预览）
    }

    // 4. 触摸移动：阻止图片原生双指预览，允许页面整体缩放
    function handleTouchMove(e: TouchEvent) {
      const target = e.target as HTMLImageElement;
      // 仅针对图片的双指操作：阻止图片单独预览，不阻止页面缩放
      if (target.tagName === 'IMG' && e.touches.length === 2) {
        e.preventDefault(); // 关键：阻止浏览器弹出图片预览遮罩
        // 不阻止事件冒泡，让浏览器捕获双指事件，触发页面整体缩放
      }
    }

    // 5. 拦截图片点击：避免点击弹出原生预览
    function handleImgClick(e: MouseEvent) {
      const target = e.target as HTMLImageElement;
      if (target.tagName === 'IMG') {
        e.preventDefault(); // 阻止点击图片的原生预览
        // 放大页面
      }
    }
    // 6. 组件卸载：解绑事件，避免内存泄漏
    onUnmounted(() => {
      if (!htmlRef.value) return;
      const imgs = htmlRef.value.querySelectorAll('img');
      imgs.forEach(img => {
        img.removeEventListener('touchstart', handleTouchStart);
        img.removeEventListener('touchmove', handleTouchMove);
        img.removeEventListener('click', handleImgClick);
      });
      // 禁止全局缩放：限制最大/最小缩放为 1.0，禁止浏览器默认缩放
    });

    return {
      agreementContent,
    };
  },
});
